import { Expose } from 'class-transformer';

export class TicketExtraFeeApiModel {
  @Expose()
  id: string;

  @Expose()
  name: string;

  @Expose()
  price: number;

  @Expose()
  isOptional: boolean;

  @Expose()
  extraFeeId: string;

  @Expose()
  defaultPriceLevelPrice: number;

  tag: string | null = null;
}
